<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="multisteps-form mb-5">
          <div class="row">
            <div class="position-sticky fixed-top z-index-sticky">
              <vsud-alert v-show="alertShow" class="mt-1 mx-6 text-center" :color="colorAlert">{{ textAlert
              }}</vsud-alert>
            </div>
            <!-- <div class="col-12 col-lg-8 mx-auto my-5">
              <h3>Formulario de registro usuario administrador.</h3>
            </div> -->
          </div>
          <!--form panels-->
          <div class="text-end">
                <div class="Nuevo usuario administrativo">
                  <router-link to="/usuarios/administrativos"><button type="button" class="btn bg-gradient-dark">Listado</button></router-link>
            </div>
            <router-view/>
          </div>
          <div class="row">
            <div class="col-12 m-auto">
              <form v-on:submit="sendForm($event)" class="multisteps-form__form mb-5">
                <user-info @sendForm="saveUser" :approvers="approvers" :supervisors="supervisors" :typeDocument="typeDocument" :genders="genders" :roles="roles"
                  :errors="errors" :isFinalTab="true" :multiRole="true" :class="activeStep === 0 ? activeClass : ''" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInfo from "./components/UserInfoAdministrative.vue";
import Address from "./components/Address.vue";
import VsudAlert from "@/components/VsudAlert.vue";
import axios from "axios";

export default {
  name: "NewUser",
  components: {
    UserInfo,
    Address,
    VsudAlert,
  },
  data() {
    return {
      showMenu: false,
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      alertShow: false,
      textAlert: null,
      colorAlert: null,
      typeDocument: null,
      genders: null,
      bloodTypes: null,
      newUser: null,
      roles: null,
      eps: null,
      errors: [],
      approvers: [],
      supervisors: []
    };
  },
  methods: {
    async saveUser(user) {
      this.errors = [];
      axios
        .post(`${process.env.VUE_APP_API_BOOKAPP}users`, user, {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        })
        .then((response) => {
          this.newUser = response.data;
          if (user.image != null) {
            this.saveUserImage(user.image);
          }
          user.name = null;
          user.lastname = null;
          user.code = null;
          user.email = null;
          user.password = null;
          user.passwordConfirm = null;
          user.type_document_id = null;
          user.document = null;
          user.phone = null;
          user.address = null;
          user.gender_id = null;
          user.birth_date = null;
          user.blood_type_id = null;
          user.occupation = null;
          user.profile = null;
          user.diseases_interest = null;
          user.rol = null;
          user.approvers = [];
          user.supervisors = [];
          this.alertShow = true;
          this.textAlert = "El usuario se creo correctamente.";
          this.colorAlert = "success";
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.alertShow = false;
            this.textAlert = null;
            this.colorAlert = null;
          }, 3000);
        })
        .catch((e) => {
          if (e.response.status == 422) {
            let errors = e.response.data.errors;
            errors = Object.values(errors);
            errors.forEach((error) => {
              error.forEach((e) => {
                this.errors.push(e);
              });
            });
          } else {
            this.alertShow = true;
            this.textAlert = "Hubo un error al crear el usuario, intente nuevamente.";
            this.colorAlert = "danger";
            setTimeout(() => {
              this.alertShow = false;
              this.textAlert = null;
              this.colorAlert = null;
            }, 3000);
          }
        });
    },
    async saveUserImage(image) {
      let data = new FormData();
      data.append("image", image);
      data.append("_method", "PUT");
      axios
        .post(
          `${process.env.VUE_APP_API_BOOKAPP}users/save-image/${this.newUser.id}`,
          data,
          {
            headers: {
              Authorization: localStorage.getItem("token_bookapp"),
              conexion: localStorage.getItem("conexion"),
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
      
        })
        .catch();
    },
    nextStep() {
      if (this.activeStep < this.formSteps) {
        this.activeStep += 1;
      } else {
        this.activeStep -= 1;
      }
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    async getTypeDocument() {
      const { status, data } = await axios.get(
        `${process.env.VUE_APP_API_BOOKAPP}type-documents`,
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );

      if (status == 200) {
        this.typeDocument = data;
      } else {
        console.log("error", data);
      }
    },
    async getRoles() {
      const { status, data } = await axios.get(
        `${process.env.VUE_APP_API_BOOKAPP}roles`,
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );

      if (status == 200) {
        this.roles = data.filter((role) => {
          return  role.id != 3;
        });
      } else {
        console.log("error", data);
      }
    },
    async getGenders() {
      const { status, data } = await axios.get(
        `${process.env.VUE_APP_API_BOOKAPP}genders`,
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );

      if (status == 200) {
        this.genders = data;
      } else {
        console.log("error", data);
      }
    },
    async getUsersApprovers() {
      const { status, data } = await axios.get(`${process.env.VUE_APP_API_BOOKAPP}users/rol/7`, {
        headers: {
          Authorization: localStorage.getItem("token_bookapp"),
          conexion: localStorage.getItem("conexion"),
        },
      });

      if (status == 200) {
        this.approvers = data;
      } else {
        console.log("error", data);
      }
    },
    async getUsersSupervisors() {
      const { status, data } = await axios.get(`${process.env.VUE_APP_API_BOOKAPP}users/rol/8`, {
        headers: {
          Authorization: localStorage.getItem("token_bookapp"),
          conexion: localStorage.getItem("conexion"),
        },
      });

      if (status == 200) {
        this.supervisors = data;
      } else {
        console.log("error", data);
      }
    },
  },
  mounted() {
    this.getTypeDocument();
    this.getGenders();
    this.getRoles();
    this.getUsersSupervisors();
    this.getUsersApprovers();
  },
};
</script>
